import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CommonService } from 'src-adisco/services/common.service';
import { HomepageService } from 'src-adisco/services/homepage.service';
import { HttpclientService } from 'src/app/admin/core/services/httpclientService';
import { UserService } from 'src/app/admin/core/services/user.service';
import { GeneralDynamicContent } from 'src/app/shared/entities/general-dynamic-content';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';

@Component({
  selector: 'app-member-file',
  templateUrl: './member-file.component.html',
  styleUrls: ['./member-file.component.css'],
  providers: [MessageService, ConfirmationService],
})
export class MemberFileComponent implements OnInit {
  statusControl = new FormControl(false);
  list: any[] = [];
  visibleRow: boolean = false;
  infoMemberForm: FormGroup;
  infoContactForm: FormGroup;
  userId = localStorage.getItem('userid');
  currentUser: any;
  logoImage: any;
  listCountry: any[] = [];
  listContacts: any[] = [];
  currentMember: any;
  nameFile: string = '';
  dynamicContent: GeneralDynamicContent;
  itemContactEdit: any;
  listCivility: any[] = [];
  listRole: any[] = [];
  currentTab: number = 0;
  currentContact: any[] = [];
  codeMember: string = '';
  listStatusActif: any[] = [];
  itemCustomer: any;
  itemCivilite: any;
  itemStatus: any;
  itemRole: any;
  isChecked: boolean = false;
  checkboxValue: string = 'INACTIF';

  constructor(
    private _fb: FormBuilder,
    private _commonService: CommonService,
    private dynamicDocumentService: DynamicDocumentService,
    private _homepageService: HomepageService,
    private datePipe: DatePipe,
    private _messageService: MessageService,
    private httpClientService: HttpclientService,
    private _cdf: ChangeDetectorRef,
    public userService: UserService
  ) { }

  ngOnInit() {
    this.initForm();
    this.getListCountry();
    this.getInfoProfile();
    this.getListCivility();
    this.getListRole();
    this.getListStatus();
  }

  initForm(): void {
    this.infoMemberForm = this._fb.group({
      code: '',
      companyName: '',
      siret: '',
      vat: '',
      logo: null,
      region: '',
      address: '',
      additionalAddress: '',
      postcode: '',
      city: '',
      country: '',
      phone: '',
      fax: '',
      email: '',
      website: '',
      // status: ''
    });
    this.infoContactForm = this._fb.group({
      id: null,
      civility: null,
      creationDate: null,
      updatingDate: null,
      mobile: null,
      address: null,
      additionalAddress: null,
      postcode: null,
      city: null,
      region: null,
      country: null,
      linkToLegalEntity: null,
      dateOfLastConnectionToTheIntranetSite: null,
      firstName: '',
      lastName: '',
      phone: '',
      email: ['', Validators.required],
      job: '',
      createExtranetAccount: false,
      role: null,
      status: ''
    });
  }

  onTabChange(event: any): void {
    this.currentTab = event.index;
    if (this.currentTab === 0) {
      this.patchValueForm(this.currentMember)
    }
  }

  getListCivility(): void {
    this._commonService.getCivility().subscribe({
      next: (res) => {
        this.listCivility = res.map((item: any) => ({
          ...item,
          label: item?.mapLocalLibelle.fr_FR,
          parameterId: item?.id,
        }));
      },
      error: (error) => { },
    });
  }

  getListRole(): void {
    this._commonService.getRole().subscribe({
      next: (res) => {
        this.listRole = res.map((item: any) => ({
          ...item,
          parameterId: item?.id,
        }));
      },
      error: (error) => { },
    });
  }

  getListStatus(): void {
    this._commonService.getStatusActif().subscribe({
      next: (res) => {
        this.listStatusActif = res;
      },
      error: (error) => { },
    });
  }

  getListCountry(): void {
    this._homepageService.getCountry().subscribe({
      next: (res) => {
        this.listCountry = res.map((item: any) => ({
          ...item,
          label: item.mapLocalLibelle.fr_FR
        }));
      },
      error: (error) => { },
    });
  }

  getListContacts(code: string): void {
    this.dynamicDocumentService
      .find(
        {
          collectionName: 'dynamic_natural_person',
          filters: [
            {
              "fieldName": "linkToLegalEntity",
              "conditions": [
                {
                  "id": 1,
                  "type": "EQUALS",
                  "value": code,
                  "minValue": "",
                  "maxValue": ""
                }
              ]
            }
          ],
          sorts: {},
          page: 1,
          pageSize: 150,
        }
      )
      .subscribe((res: any) => {
        this.listContacts = res?.content;
      })
  }

  getInfoProfile(): void {
    this._commonService.getUser(this.userId).subscribe({
      next: (res) => {
        this.currentUser = res;
        if (this.currentUser?.linkToLegalEntity) {
          this.getInfoMember(this.currentUser?.linkToLegalEntity?.documentId)
        }
      },
      error: (error) => { },
    });
  }

  getInfoMember(id: string): void {
    this._commonService.getInfoMember(id).subscribe({
      next: (res) => {
        this.currentMember = res;
        this.codeMember = res?.code;
        if (this.codeMember) {
          this.getListContacts(this.codeMember);
          this._cdf.detectChanges();
        }
        this.logoImage = res.logo[0];
        this.nameFile = res.logo[0]?.name;
        this.patchValueForm(this.currentMember);
      },
      error: (error) => { },
    });
  }

  patchValueForm(data: any): void {
    this.infoMemberForm.patchValue({
      code: data?.code,
      companyName: data?.companyName,
      siret: data?.siret,
      vat: data?.vat,
      region: data?.region,
      logo: data?.logo,
      address: data?.address,
      additionalAddress: data?.additionalAddress,
      postcode: data?.postcode,
      city: data?.city,
      country: data?.country?.labels?.fr_FR,
      phone: data?.phone,
      fax: data?.fax,
      email: data?.email,
      website: data?.website,
      createExtranetAccount: data?.createExtranetAccount,
    })
  }

  mapItem(item: any) {
    return {
      parameterId: item.id,
      value: item.valeur,
      labels: {
        en_GB: item.mapLocalLibelle.en_GB,
        es_ES: item.mapLocalLibelle.es_ES,
        fr_FR: item.mapLocalLibelle.fr_FR,
        de_DE: item.mapLocalLibelle.de_DE
      }
    };
  }

  // onStatusChange(event: any) {
  //   if (event.checked && event.checked[0] == 'ACTIF') {
  //     this.statusControl.setValue(true);
  //     this.infoContactForm.patchValue({
  //       status: 'ACTIF',
  //     })
  //   }
  //   else {
  //     this.statusControl.setValue(false);
  //     this.infoContactForm.patchValue({
  //       status: 'INACTIF',
  //     })
  //   }
  // }

  mapItemToRole(item: any) {
    return {
      parameterId: item?.id,
      value: item?.valeur,
      labels: {
        fr_FR: "Role",
      }
    };
  }

  save() {
    if (this.currentTab === 0) {
      let itemCountry: any = '';
      if (this.infoMemberForm.value.country) {
        const foundItem = this.listCountry.find(item => item.mapLocalLibelle.fr_FR === this.infoMemberForm.value.country);
        if (foundItem) {
          itemCountry = this.mapItem(foundItem);
        }
      }
      if (!this.infoMemberForm.valid || !this.currentMember) {
        return;
      }
      this.currentMember.code = this.infoMemberForm.get('code')?.value || '';
      this.currentMember.companyName = this.infoMemberForm.get('companyName')?.value || '';
      this.currentMember.siret = this.infoMemberForm.get('siret')?.value || '';
      this.currentMember.vat = this.infoMemberForm.get('vat')?.value || '';
      this.currentMember.region = this.infoMemberForm.get('region')?.value || '';
      // this.currentMember.logo = this.infoMemberForm.get('logo')?.value || '';
      this.currentMember.address = this.infoMemberForm.get('address')?.value || '';
      this.currentMember.additionalAddress = this.infoMemberForm.get('additionalAddress')?.value || '';
      this.currentMember.postcode = this.infoMemberForm.get('postcode')?.value || '';
      this.currentMember.city = this.infoMemberForm.get('city')?.value || '';
      this.currentMember.country = itemCountry || '';
      this.currentMember.phone = this.infoMemberForm.get('phone')?.value || '';
      this.currentMember.fax = this.infoMemberForm.get('fax')?.value || '';
      this.currentMember.email = this.infoMemberForm.get('email')?.value || '';
      this.currentMember.website = this.infoMemberForm.get('website')?.value || '';
      // this.currentMember.status = this.infoMemberForm.get('status')?.value || '';
      this.currentMember.updatingDate = this.datePipe.transform(Date.now(), "yyyy-MM-dd'T'00:00:00");
      this.currentMember.creationDate = this.datePipe.transform(
        this.currentUser.creationDate,
        "yyyy-MM-dd'T'HH:mm:ss"
      );
      this.dynamicDocumentService
        .saveDocument('dynamic_legal_entity', this.currentMember, true)
        .subscribe({
          next: (res) => {
            this._messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: "Les détails de l'utilisateur ont été enregistrés avec succès",
              life: 3000
            });
            this.patchValueForm(res);
          },
          error: (_err) => {
            this._messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: "Échec de l'enregistrement des détails de l'utilisateur",
              life: 3000
            });
          }
        });
    }
    if (this.currentTab === 1) {
      this.itemCivilite = {};
      this.itemRole = {};
      this.itemStatus = {};
      if (!this.infoContactForm.valid) {
        return;
      }
      if (this.infoContactForm.value.civility) {
        const foundItemCivilite = this.listCivility.find(item => item.id === this.infoContactForm.value.civility);
        if (foundItemCivilite) {
          this.itemCivilite = this.mapItem(foundItemCivilite);
        }
      }
      if (this.infoContactForm.value.role) {
        const foundItemRole = this.listRole.find(item => item.id === this.infoContactForm.value.role);
        if (foundItemRole) {
          this.itemRole = this.mapItem(foundItemRole);
        }
      }

      const foundItemStatus = this.listStatusActif.find(item => (item.valeur === (this.infoContactForm.value.createExtranetAccount ? "ACTIF" : "INACTIF")));

      if (foundItemStatus?.id) {
        this.itemStatus = [foundItemStatus.id];
      }

      if (this.infoContactForm.value?.id) {
        this.convertDataUpdateIem();
        this.saveValueForm(this.itemContactEdit);
      }
      else {
        if (this.infoContactForm.value.role) {
          this.infoContactForm.patchValue({
            role: [this.infoContactForm.value.role],
          })
        }
        if (this.infoContactForm.value.civility) {
          this.infoContactForm.patchValue({
            civility: [this.infoContactForm.value.civility],
          })
        }
        if (this.currentMember) {
          this.infoContactForm.patchValue({
            // linkToLegalEntity: [this.currentMember?.id],
            linkToLegalEntity: this.currentMember?.id,
          })
        }

        const foundItemStatus = this.listStatusActif.find(item => (item.valeur === (this.infoContactForm.value.createExtranetAccount ? "ACTIF" : "INACTIF")));

        if (foundItemStatus?.id) {
          this.infoContactForm.patchValue({
            status: [foundItemStatus.id],
          })
        };

        this.saveValueForm(this.infoContactForm.value);
      }
    }
  }

  convertDataUpdateIem(): void {
    this.itemContactEdit.civility = this.itemCivilite || '';
    this.itemContactEdit.status = this.itemStatus || '';
    this.itemContactEdit.createExtranetAccount = this.infoContactForm.value.createExtranetAccount ?? false;
    this.itemContactEdit.role = this.itemRole || '';
    this.itemContactEdit.firstName = this.infoContactForm.value.firstName;
    this.itemContactEdit.lastName = this.infoContactForm.value.lastName;
    this.itemContactEdit.phone = this.infoContactForm.value.phone;
    this.itemContactEdit.email = this.infoContactForm.value.email;
    this.itemContactEdit.job = this.infoContactForm.value.job;
    this.itemContactEdit.updatingDate = this.datePipe.transform(Date.now(), "yyyy-MM-dd'T'00:00:00");
    this.itemContactEdit.creationDate = this.datePipe.transform(
      this.currentUser.creationDate,
      "yyyy-MM-dd'T'HH:mm:ss"
    );
    this.itemContactEdit.dateOfLastConnectionToTheIntranetSite = this.datePipe.transform(
      this.currentUser.dateOfLastConnectionToTheIntranetSite,
      "yyyy-MM-dd'T'HH:mm:ss"
    );
  }

  saveValueForm(data: any): void {
    this.dynamicDocumentService
      .saveDocument('dynamic_natural_person', data, true)
      .subscribe({
        next: (res) => {
          if (this.codeMember) {
            this.getListContacts(this.codeMember);
            this.resetFormContact();
            this._cdf.detectChanges();
          }
          this._messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: "Les contacts ont été enregistrés avec succès",
            life: 3000
          });
          this.patchValueForm(res);
        },
        error: (err) => {
          this._messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: "Échec de l'enregistrement du contact",
            life: 3000
          });
        }
      });
  }

  selectImage(event: any): void {
    let selectedFile = event.target.files[0];
    if (!selectedFile) {
      return;
    }
    this.nameFile = selectedFile?.name;
    this.logoImage = selectedFile;
    this.uploadFile(selectedFile);
  }

  uploadFile(file: any) {
    const formData = new FormData();
    formData.append('file', file);

    this.httpClientService
      .postWithHeader(formData, {}, '/resource-files')
      .subscribe({
        next: (resourceFile) => {
          this.currentMember.logo = [this.convertFieldImage(resourceFile)];

          this.infoMemberForm.patchValue({
            logo: [this.convertFieldImage(resourceFile)]
          })
        },
        error: (error) => {
        },
      });
  }

  convertFieldImage(file: any) {
    return {
      resourceFileId: file.id,
      name: file?.name,
      url: file?.url
    };
  }

  showDialogDelRow(data: any) {
    this.visibleRow = true;
    this.itemCustomer = data;
    this.resetFormContact()
  }

  resetFormContact(): void {
    this.infoContactForm.reset();
    this.itemContactEdit = null;
    this.infoContactForm.patchValue({ createExtranetAccount: false });
    this.isChecked = false;
  }

  confirmDeleteCustomer(): void {
    this._commonService.deleteContactMember(this.itemCustomer?.id).subscribe({
      next: (_res) => {
        this.visibleRow = false;
        this.getListContacts(this.codeMember);
        this._cdf.detectChanges();
      },
      error: (_error) => { },
    });
  }

  editItemContact(item: any) {
    this._commonService.getUser(item?.id).subscribe({
      next: (res) => {
        this.itemContactEdit = res;
        if (this.itemContactEdit) {
          this.patchValueItemContact(this.itemContactEdit);
        }
      },
      error: (_error) => { },
    });
  }

  patchValueItemContact(item: any): void {
    this.infoContactForm?.patchValue({
      id: item?.id,
      civility: item?.civility?.parameterId,
      role: item?.role?.parameterId,
      firstName: item?.firstName,
      lastName: item?.lastName,
      phone: item?.phone,
      email: item?.email,
      job: item?.job,
      status: item?.status?.value,
      createExtranetAccount: item?.createExtranetAccount
    })
    if (item?.createExtranetAccount) {
      this.isChecked = true;
    }
    else {
      this.isChecked = false;
    }
  }

  onCheckboxChange(event: any) {
    if (event) {
      this.infoContactForm.patchValue({
        createExtranetAccount: true,
      })
    }
    else {
      this.infoContactForm.patchValue({
        createExtranetAccount: false
      })
    }
  }

  checkDisplaySaveButton() {
    if (this.userService.hasExtranetAccess('fonctions', 'gestion-marques')) {
      this.infoMemberForm?.disabled && this.infoMemberForm.enable();
      this.infoContactForm?.disabled && this.infoContactForm.enable();
      return true;
    } else {
      this.infoMemberForm?.enabled && this.infoMemberForm.disable();
      this.infoContactForm?.enabled && this.infoContactForm.disable();
      return false;
    }
  }
}
